import {
  trackClick, trackOmniture,
  trackPageVisits
} from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';

export const RAILS_LANDING_PNR_PAGE_NAME = 'mob:funnel:ris:pnr:pnrlanding';
export const RAILS_LANDING_LTS_PAGE_NAME = 'mob:funnel:ris:lts:ltslanding';
export const RAIL_LANDING_SEAT_AVAIL_PAGE_NAME = 'mob:funnel:ris:seatavail:seatavaillanding';
export const RAIL_LANDING_TRAIN_SCHD_PAGE_NAME = 'mob:funnel:ris:trainschedule:schedulelanding';
export const RAIL_LANDING_COACH_POSITION_PAGE_NAME = 'mob:funnel:ris:pwa:coachposition:cplanding';
export const RAILS_LANDING_LIVE_STATION_PAGE_NAME = 'mob:funnel:ris:pwa:livestation:livestnlanding';

let PNR_LANDING_SEQUENCE;
let LTS_LANDING_SEQUENCE;
let SEAT_AVAIL_LANDING_SEQUENCE;
let TRAIN_SCHD_LANDING_SEQUENCE;
let LIVE_STATION_LANDING_SEQUENCE;

export const omnitureMap = {
  Wallet_Reward: 'AIR',
  Recent_Search: 'RecentSearch'
};

export const PAGE_NAME = [
  '',
  RAILS_LANDING_PNR_PAGE_NAME,
  RAILS_LANDING_LTS_PAGE_NAME
];
export const SWITCHER_NAME = [
  'Rails_BOOKING_Tab_clicked',
  'Rails_PNR_Tab_clicked',
  'Rails_LTS_Tab_clicked'
];

class RailsLandingTrackingHelper {
  trackLandingPnrPageVisit = () => {
    const params = {};
    trackPageVisits(RAILS_LANDING_PNR_PAGE_NAME, params);
  };

  trackLandingCoachPositionPageVisit = () => {
    const params = {};
    trackPageVisits(RAIL_LANDING_COACH_POSITION_PAGE_NAME, params);
  };

  trackLandingTrainSchedulePageVisit = () => {
    const params = {};
    trackPageVisits(RAIL_LANDING_TRAIN_SCHD_PAGE_NAME, params);
  };

  trackLandingLiveTrainPageVisit = trackingParams => {
    const params = { ...trackingParams };
    trackPageVisits(RAILS_LANDING_LTS_PAGE_NAME, params);
  };

  trackLandingLiveStationPageVisit = () => {
    const params = {};
    trackPageVisits(RAILS_LANDING_LIVE_STATION_PAGE_NAME, params);
  };

    trackSwitcherClicked = (clickIndex, pageIndex) => {
      const params = {};
      RailsLandingTrackingHelper.trackCommonClickWithSource(PAGE_NAME[pageIndex], SWITCHER_NAME[clickIndex], params);
    };

    trackCardClicked = (pageName, cardData) => {
      const params = {};
      params.m_c50 = cardData;
      RailsLandingTrackingHelper.trackCommonClick(pageName, params);
    };

    trackClick = (pageName, clickSource) => {
      const params = {};
      RailsLandingTrackingHelper.trackCommonClickWithSource(pageName, clickSource, params);
    };

    trackError = (pageName, error) => {
      const params = {};
      params.pagename = pageName;
      params.m_v15 = pageName;
      params.m_v22 = error;
      trackOmniture(pageName, params);
    };

    setPnrCardData = (sequence) => {
      if (sequence && sequence.length > 4) {
        PNR_LANDING_SEQUENCE = sequence;
      }
    };

    setSeatAvailCardData = (sequence) => {
      if (sequence && sequence.length > 4) {
        SEAT_AVAIL_LANDING_SEQUENCE = sequence;
      }
    };

    setTrainSchdCardData = (sequence) => {
      if (sequence && sequence.length > 4) {
        TRAIN_SCHD_LANDING_SEQUENCE = sequence;
      }
    };

    setLtsCardData = (sequence) => {
      if (sequence && sequence.length > 4) {
        LTS_LANDING_SEQUENCE = sequence;
      }
    };

  setLiveStationCardData = (sequence) => {
    if (sequence && sequence.length > 4) {
      LIVE_STATION_LANDING_SEQUENCE = sequence;
    }
  };

  static trackCommonClick(pageName, params) {
    if (RailsLandingTrackingHelper.getSequenceForPage(pageName)) {
      params.m_v44 = RailsLandingTrackingHelper.getSequenceForPage(pageName);
    }
    trackOmniture(pageName, params);
  }

  static trackCommonClickWithSource(pageName, clickSource, params) {
    if (RailsLandingTrackingHelper.getSequenceForPage(pageName)) {
      params.m_v44 = RailsLandingTrackingHelper.getSequenceForPage(pageName);
    }
    trackClick(pageName, clickSource, params);
  }

  static getSequenceForPage(pageName) {
    if (pageName === RAILS_LANDING_PNR_PAGE_NAME) {
      return PNR_LANDING_SEQUENCE;
    } else if (pageName === RAILS_LANDING_LTS_PAGE_NAME) {
      return LTS_LANDING_SEQUENCE;
    } else if (pageName === RAIL_LANDING_SEAT_AVAIL_PAGE_NAME) {
      return SEAT_AVAIL_LANDING_SEQUENCE;
    } else if (pageName === RAIL_LANDING_TRAIN_SCHD_PAGE_NAME) {
      return TRAIN_SCHD_LANDING_SEQUENCE;
    } else if (pageName === RAILS_LANDING_LIVE_STATION_PAGE_NAME) {
      return LIVE_STATION_LANDING_SEQUENCE;
    }
    return undefined;
  }
}

export default new RailsLandingTrackingHelper();
